import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string[];
  image?: string;
  url?: string;
  type?: 'website' | 'article' | 'profile' | 'product';
  noindex?: boolean;
}

export function SEO({
  title = 'RoyaltySuite',
  description = 'A social platform for distinguished individuals',
  keywords = ['social network', 'community', 'premium', 'exclusive'],
  image = 'https://royaltysuite.com/og-image.jpg',
  url = typeof window !== 'undefined' ? window.location.href : '',
  type = 'website',
  noindex = false
}: SEOProps) {
  const fullTitle = title === 'RoyaltySuite' ? title : `${title} | RoyaltySuite`;

  return (
    <Helmet>
      {/* Basic */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(', ')} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="RoyaltySuite" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': type === 'website' ? 'WebSite' : type === 'article' ? 'Article' : 'WebPage',
          name: title,
          description,
          url,
          image,
          publisher: {
            '@type': 'Organization',
            name: 'RoyaltySuite',
            logo: {
              '@type': 'ImageObject',
              url: 'https://royaltysuite.com/logo.png'
            }
          }
        })}
      </script>
    </Helmet>
  );
}